import React from 'react'
import ARViewer from './ARViewer'
import GLBViewer from './GLBViewer'
import AdminProductView from './AdminProductView'
import appUrl from '../config'

import AndroidArViewer from './AndroidArViewer';

import styled from '@emotion/styled';

const FurnitureViewerContainer = styled('div')({
    width: "100%",
    display: 'flex',
    gap: '20px',
    direction: 'row',
    padding: "20px",
});

const QRContainer = styled('div')({
    display: 'grid',
    gridGap: '20px',
    gridTemplateRows: '1fr 1fr',
    direction: 'column',
});

const FurnitureViewer = ({glbUrl, usdzUrl, productId}) => {
  return (
    <FurnitureViewerContainer>
      <QRContainer>
        <ARViewer fileUrl={usdzUrl} title="iOS" />
        <ARViewer fileUrl={`${appUrl.appUrl}android_viewer/${encodeURIComponent(glbUrl)}`}  title="Android" />
      </QRContainer>
      <GLBViewer fileUrl={glbUrl} />
      <AdminProductView productId={productId} />
    </FurnitureViewerContainer>
  )
}

export default FurnitureViewer